import axios from '@/utils/ajax/index'; // 倒入 api
import fileExport from '@/utils/fileExport/index'; // 导出文件 api

// 药品列表
export const drugs = (data) => {
  return axios({
    url: '/drugsManage/drugs/list',
    method: 'post',
    data,
  });
};

// 删除药品
export const drugsDel = (data) => {
  return axios({
    url: `/drugsManage/drugs/${data.id}`,
    method: 'DELETE',
    data,
  });
};

// 批量删除药品
export const drugsDelMore = (data) => {
  return axios({
    url: '/drugsManage/drugs/batch',
    method: 'DELETE',
    data,
  });
};

// 批量编辑自定义药品
export const batchModifyDrugCustomType = (data) => {
  return axios({
    url: '/drugsManage/drugs/batchModifyDrugCustomType',
    method: 'PUT',
    data,
  });
};

// 查找药品自定义类型
export const customType = (params) => {
  return axios({
    url: '/drugsManage/drugs/customType',
    method: 'get',
    params,
  });
};

// 药品信息导出
export const drugExport = (params) => {
  const path = '/drugsManage/drugs/excel/inventory';
  fileExport(path, params);
};

// 新增药品时查找药品下拉框SUG
export const nameList = (data) => {
  return axios({
    url: '/drugsManage/drugs/nameList',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 查找生产厂家下拉框
export const manufacturer = (params) => {
  return axios({
    url: '/drugsManage/drugs/manufacturer',
    method: 'get',
    params,
  });
};

// 快速编辑药品
export const convenientEdit = (data) => {
  return axios({
    url: '/drugsManage/drugs/convenientEdit',
    method: 'PUT',
    data,
  });
};

// 查找药品详情
export const durgDetail = (params) => {
  return axios({
    url: `/drugsManage/drugs/${params.id}/detail`,
    method: 'get',
    params,
  });
};

// 新增药品
export const addDrugs = (data) => {
  return axios({
    url: '/drugsManage/drugs',
    method: 'post',
    data,
  });
};

// 更新药品
export const updateDrugs = (data) => {
  return axios({
    url: '/drugsManage/drugs',
    method: 'PUT',
    data,
  });
};

// 查询本地库是否存在相同药品
export const checkDrug = (params) => {
  return axios({
    url: '/drugsManage/drugs/checkDrugRepeatedByStandDrugIdAndBarCode',
    method: 'get',
    params,
  });
};

// 删除药品单位
export const delUnit = (data) => {
  return axios({
    url: `/drugsManage/drugs/unit/${data.id}`,
    method: 'DELETE',
    data,
  });
};

// 查找标准库药品信息
export const drugStandDetail = (params) => {
  return axios({
    url: `/drugsManage/drugs/${params.id}/drugStandDetail`,
    method: 'get',
    params,
  });
};

// 根据标准库ID以及生产厂家以及药品类型查询药品详情
export const drugDetail = (params) => {
  return axios({
    url: '/drugsManage/drugs/hospitalDrug/detail',
    method: 'get',
    params,
  });
};

export const upload = (data) => {
  return axios({
    url: '/upload',
    method: 'post',
    data,
  });
};

// 流向查询
export const flow = (data) => {
  return axios({
    url: '/drugsManage/flow',
    method: 'post',
    data,
  });
};

// 效期预警查询
export const validity = (params) => {
  return axios({
    url: `/drugsManage/validityWarning/validity/${params.days}`,
    method: 'get',
    params,
  });
};

// 获取盘点单列表
export const stocktaking = (data) => {
  return axios({
    url: '/drugsManage/stocktaking/list',
    method: 'post',
    data,
  });
};

// 获取盘点单
export const getStocktaking = (params) => {
  return axios({
    url: `/drugsManage/stocktaking/${params.id}`,
    method: 'get',
    params,
  });
};

// 修改盘点单
export const updateStocktaking = (data) => {
  return axios({
    url: `/drugsManage/stocktaking/${data.id}`,
    method: 'PUT',
    data,
  });
};

// 删除盘点单
export const delStocktaking = (params) => {
  return axios({
    url: `/drugsManage/stocktaking/${params.id}`,
    method: 'DELETE',
    params,
  });
};

// 获取新增盘点单的id
export const stocktakingId = (data) => {
  return axios({
    url: '/drugsManage/stocktaking',
    method: 'post',
    data,
  });
};

// 获取药品名下拉列表
export const drugsNameList = (data) => {
  return axios({
    url: '/drugsManage/drugs/drugsNameList',
    method: 'post',
    data,
  });
};

// 获取未盘点药品列表
export const notStocktaking = (data) => {
  return axios({
    url: '/drugsManage/stocktakingDetail/not',
    method: 'post',
    data,
  });
};

// 获取已盘点药品列表
export const alStocktaking = (data) => {
  return axios({
    url: '/drugsManage/stocktakingDetail/already',
    method: 'post',
    data,
  });
};

// 确认一条盘点单
export const stocktakingDetail = (data) => {
  return axios({
    url: '/drugsManage/stocktakingDetail',
    method: 'post',
    data,
  });
};

// 取消一条盘点单
export const stocktakingDetailDel = (data) => {
  return axios({
    url: `/drugsManage/stocktakingDetail/${data.id}`,
    method: 'DELETE',
    data,
  });
};

// 盘点单导出
export const stocktakingExport = (params) => {
  const path = '/drugsManage/stocktakingDetail/excel';
  fileExport(path, params);
};

// 库存预警列表/drugsManage/purchasing/drug/batchInstock/detail/{drugId}
export const inventoryWarnings = (params) => {
  return axios({
    url: '/drugsManage/drug/inventoryWarnings',
    method: 'get',
    params,
  });
};

// 根据药品查询入库批次详情
export const batchInstockDetail = (params) => {
  return axios({
    url: `/drugsManage/purchasing/drug/batchInstock/detail/${params.drugId}`,
    method: 'get',
    params,
  });
};

// 药品库存管理记录
export const inventoryManage = (data) => {
  return axios({
    url: '/drugsManage/inventoryManage',
    method: 'post',
    data,
    // allData: true, // 是否需要全部的body
  });
};

// 药品库存管理记录导出
export const inventoryManageExport = (params) => {
  const path = '/drugsManage/inventoryManage/export';
  fileExport(path, params);
};

/**
 * 采购管理
*/

// 采购单查询
export const batchInstock = (data) => {
  return axios({
    url: '/drugsManage/purchasing/batchInstock',
    method: 'post',
    data,
  });
};

// 模糊搜索查询
export const getDrugById = (params) => {
  return axios({
    url: '/drugsManage/purchasing/drug/getDrugById',
    method: 'get',
    params,
  });
};

// 药品名查询
// export const getDrugByName = (params) => {
//   return axios({
//     url: '/drugsManage/purchasing/drug/getDrugByName',
//     method: 'get',
//     params,
//     hideLoading: true,
//   });
// };


/**
 * 药品管理
*/

// 药品查询药品信息下拉框
export const getDrugByName = (data) => {
  return axios({
    url: '/drugsManage/purchasing/drug/getDrugByName',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 根据id查药品信息
export const getDrugInfo = (params) => {
  return axios({
    url: '/drugsManage/purchasing/drug/getDrugById',
    method: 'get',
    params,
  });
};

// 药品入库/修改
export const batchInstockOperation = (data) => {
  return axios({
    url: '/drugsManage/purchasing/batchInstockOperation',
    method: 'post',
    data,
  });
};

// 批次详情查询
export const purchasingDetail = (params) => {
  return axios({
    url: `/drugsManage/purchasing/detail/${params.id}`,
    method: 'get',
    // params,
  });
};

// 确认入库
export const instockConfirm = (params) => {
  return axios({
    url: `/drugsManage/purchasing/instockConfirm/${params.id}`,
    method: 'get',
  });
};


// 取消批次入库单
export const cancelBatchInstock = (params) => {
  return axios({
    url: `/drugsManage/purchasing/cancelBatchInstock/${params.id}`,
    method: 'get',
  });
};

// 删除批次内药品
export const instockDelete = (params) => {
  return axios({
    url: `/drugsManage/purchasing/instockDelete/${params.batchNo}/${params.id}`,
    method: 'get',
  });
};

// 药品流向记录导出
export const flowExport = (params) => {
  const path = '/drugsManage/flow/export';
  fileExport(path, params);
};

// 退货
export const instockReturn = (data) => {
  return axios({
    url: '/drugsManage/purchasing/instockReturn',
    method: 'post',
    data,
  });
};

// 出库药品查询
export const outOfStockDrugs = (params) => {
  return axios({
    url: '/drugsManage/purchasing/outOfStockDrugs',
    method: 'get',
    params,
    hideLoading: true,
  });
};

// 出库单出库/修改
export const outOfStockOperation = (data) => {
  return axios({
    url: '/drugsManage/purchasing/outOfStockOperation',
    method: 'post',
    data,
  });
};

// 出库确认
export const outStockConfirm = (params) => {
  return axios({
    url: `/drugsManage/purchasing/outStockConfirm/${params.batchInstockId}`,
    method: 'get',
  });
};

export const instockRreturnRecord = (params) => {
  return axios({
    url: `/drugsManage/purchasing/instockReturnRecord/${params.id}`,
    method: 'get',
  });
};

// 批次详情查询
export const batchInstockId = (params) => {
  return axios({
    url: `/drugsManage/purchasing/drug/batchInstock/detail/${params.id}`,
    method: 'get',
  });
};

//  字典表
export const searchDictionary = (data) => {
  return axios({
    url: '/dict/searchDictionary',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 导入药品信息模板下载
export const downloadDrugInfomationTemplate = (params) => {
  const path = '/drugsManage/drugs/downloadDrugInfomationTemplate';
  fileExport(path, params);
};

// 查询商城订单列表
export const shopOrderToStorage = (params) => {
  return axios({
    url: '/drugsManage/purchasing/shopOrderToStorage',
    method: 'get',
    params,
  });
};

// 取消订单入库
export const cancleShopOrder = (data) => {
  return axios({
    url: `/drugsManage/purchasing/cancleShopOrder/${data.id}`,
    method: 'PUT',
    data,
  });
};

// 取消订单入库
export const addShopDrugs = (data) => {
  return axios({
    url: '/drugsManage/purchasing/addShopDrugs',
    method: 'post',
    data,
  });
};

// 效期提醒导出
export const validityExport = (params) => {
  const path = `/drugsManage/validityWarning/validity/excel/${params.days}`;
  fileExport(path, params);
};

// 盘点详情导出
export const inventoryExport = (params) => {
  const path = `/drugsManage/stocktakingDetail/${params.id}/excel`;
  fileExport(path, params);
};
// 批次详情列表导出
export const batchDetailExport = (params) => {
  const path = `/drugsManage/purchasing/detail/excel/${params.batchInstockId}`;
  fileExport(path, params);
};

// 批次详情信息
export const detailInfo = (params) => {
  return axios({
    url: `/drugsManage/purchasing/detail/detailInfo/${params.batchInstockId}`,
    method: 'get',
    params,
  });
};

// 批次详情列表
export const detailList = (params) => {
  return axios({
    url: `/drugsManage/purchasing/detail/list/${params.batchInstockId}`,
    method: 'get',
    params,
  });
};

// 根据批号查询药品的批次 信息
export const getBatchDrugDetail = (params) => {
  return axios({
    url: `/drugsManage/getBatchDrugDetail/${params.outOfStockId}`,
    method: 'get',
    params,
  });
};

export default {
  drugs,
  drugsDel,
  drugsDelMore,
  batchModifyDrugCustomType,
  customType,
  drugExport,
  nameList,
  manufacturer,
  convenientEdit,
  durgDetail,
  addDrugs,
  updateDrugs,
  checkDrug,
  delUnit,
  drugStandDetail,
  drugDetail,
  upload,
  flow,
  validity,
  stocktaking,
  getStocktaking,
  updateStocktaking,
  delStocktaking,
  stocktakingId,
  notStocktaking,
  stocktakingDetail,
  stocktakingDetailDel,
  alStocktaking,
  drugsNameList,
  stocktakingExport,
  inventoryWarnings,
  batchInstockDetail,
  inventoryManage,
  inventoryManageExport,
  batchInstock,
  getDrugById,
  getDrugByName,
  flowExport,
  getDrugInfo,
  batchInstockOperation,
  purchasingDetail,
  instockConfirm,
  instockDelete,
  cancelBatchInstock,
  instockRreturnRecord,
  instockReturn,
  outOfStockDrugs,
  outOfStockOperation,
  outStockConfirm,
  batchInstockId,
  searchDictionary,
  downloadDrugInfomationTemplate,
  shopOrderToStorage,
  cancleShopOrder,
  addShopDrugs,
  validityExport,
  inventoryExport,
  batchDetailExport,
  detailInfo,
  detailList,
  getBatchDrugDetail,
};
